import React from 'react';
import { useSelector } from 'react-redux';
import { combineClassNames } from '../../app/functions';
import WelcomeSection from './sections/welcome-section';
import ExpectationsSection from './sections/expectations-section';
import OffersSection from './sections/offers-section';
import ReasonsSection from './sections/reasons-section';
import TeamSection from './sections/team-section';
import './index.scss';

const Home = ({ isMobileApp }) => {
    const insurancePage = useSelector((store) => store.insurancePage);

    return (
        <main className={combineClassNames(
            'home',
            isMobileApp && 'home_mobile-app',
        )}>
            <WelcomeSection />

            {insurancePage?.expectations?.length > 0 && (
                <ExpectationsSection />
            )}

            <OffersSection isMobileApp={isMobileApp} />

            {insurancePage?.reasons?.length > 0 && (
                <ReasonsSection />
            )}

            {insurancePage?.team?.length > 0 && (
                <TeamSection />
            )}
        </main>
    );
};

export default Home;
